<template>
	<div class="job-profile--place-of-work-edit">
		<PostalCodeEdit
			:value="value"
			:meta="meta"
			multiple
			@input="$emit('input', $event)"
		/>
	</div>
</template>

<script>
import PostalCodeEdit from "@/vue/common/postal-code/Edit";
import {mapState} from "vuex";

export default {

	components: {
		PostalCodeEdit,
	},

	props: {
		value: {
			type: Object,
			required: false,
		}
	},

	computed: {
		...mapState('meta', [
			'meta',
		]),
	},
}
</script>
